import { Vue, Component, Prop, Watch, Emit } from 'vue-property-decorator';
import { Getter } from 'vuex-class';

import Field from '@/../bower_components/teknisavuecomponents/assets/interfaces/Field';
import TkForm from '@/../bower_components/teknisavuecomponents/components/TkForm.vue';
import SnackbarUtils from '@/../bower_components/teknisavuecomponents/assets/utils/SnackbarUtils';
import DocumentosController from '@/assets/ts/controller/DocumentosController';
import RelatorioController from '@/assets/ts/controller/RelatorioController';
import store from '@/store/store';
import { format } from 'date-fns';

@Component({
  name: 'AprovaReprovaAssinaturaPopup',
  components: {
    TkForm,
  },
})
class AprovaReprovaAssinaturaPopup extends Vue {
  // #region [ PROPS ]
  @Prop({ default: false })
  private value: boolean;

  @Prop({ default: {} })
  private rowSelected: any;

  @Prop({ default: true })
  private isAprova: boolean;
  // #endregion

  // #region [ STORE ]
  @Getter('popUpSize')
  private readonly popUpSize: string;
  // #endregion

  // #region [ EVENTS ]
  @Emit('after-save')
  private emitAfterSave() {}

  @Emit('input')
  private emitInput(value: boolean) {}
  // #endregion

  // #region [ DATA ]
  private row: any = {};
  private internalValue = false;
  private loading = false;

  // #endregion

  // #region [ COMPUTED ]
  private get fields(): Field[] {
    const fields = [
      {
        name: 'DSREJEICAO',
        label: 'Motivo de Rejeição',
        type: 'textarea',
        size: 12,
        rows: 2,
        isVisible: !this.isAprova
      },
    ];

    return fields;
  }

  private get isValid(): boolean {
    const isValid = true;

    return isValid;
  }
  // #endregion

  // #region [ WATCHERS ]
  @Watch('value', { immediate: true })
  private valueOnChange() {
    this.internalValue = this.value;
  }
  // #endregion

  // #region [ METHODS ]
  private closeDialog() {
    this.internalValue = false;
    this.emitInput(this.internalValue);
  }

  private async save() {
    if (!this.isValid) {
      const message = 'Preencha todos os campos obrigatórios!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      return;
    }

    this.loading = true;

    try {

      if(this.isAprova) {
        await this.aprovaAssinatura();
      } else {
        await this.reprovaAssinatura();
      }

      this.closeDialog();
      this.emitAfterSave();
    } finally {
      this.loading = false;
    }

  }


  private async aprovaAssinatura() {
    await this.verificaAssinaturaVinculo(this.rowSelected.NRVINCULOM);

    let reportData = {
      dsReport: '',
      dtCompetencia: '',
      nrPeriodo: '',
      nmVinculo: '',
      reportName: ''
    }
    try {
      const [ dsReport, dtCompetencia, nrPeriodo, nmVinculo ] = this.rowSelected.NMDOCUMENTO.split(' - ');
      const reportName = this.rowSelected.NMCATEGDOCUMENTO;
      reportData = { dsReport , dtCompetencia, nrPeriodo, nmVinculo, reportName};

      
      if(!nrPeriodo) {
        this.naoFoiEncontradoPeriodo();
      }
    } catch (error) {
      this.naoFoiEncontradoPeriodo();
    }

    const rowReport = {
      CDOPERADOR: store.getters.user.cdoperador,
      reportName: reportData.reportName,
      P_NRORG: store.getters.user.nrorg,
      P_VINCULO: this.rowSelected.NRVINCULOM,
      P_COMPETENCIA: reportData.dtCompetencia,
      P_PERIODO: reportData.nrPeriodo,
      P_NAOEXIGIMARC: 'S',
      P_TPVINCULO: store.getters.user.nrtipovinculom,
      P_ESTRUTLEGAL: this.rowSelected.NRESTRUTLEGAL,
      P_ESTRUTGEREN: this.rowSelected.NRESTRUTGEREN,
      P_DATA_HORA_ACEITE_VINCULO: format(new Date(), 'dd/MM/yyyy'),
      P_ACEITEVINCULO: 'S',
      P_PARCEIRO_ASSINATURA: this.rowSelected.NRPARCNEGOCIO
    }

    let dtAceiteVinculo = format(new Date(), 'dd/MM/yyyy');

    if (this.rowSelected.DTACEITEVINCULO) {
      dtAceiteVinculo = this.rowSelected.DTACEITEVINCULO.split(" ")[0];
    }

    if(this.rowSelected.ISACEITEGESTOR == 'S') {
      rowReport['P_ACEITEGESTOR'] = 'S';
      rowReport['P_DATA_HORA_ACEITE_GESTOR'] = format(new Date(), 'dd/MM/yyyy');
    }

    const reportLink = await RelatorioController.generateReport(rowReport);

    const rowChange =   {
      FILE: reportLink,
      ISACEITE: 'S',
      NRINTELETRDIGIT: this.rowSelected.NRINTELETRDIGIT,
      ISACEITEGESTOR: this.rowSelected.ISACEITEGESTOR,
      NRVINCULOM: this.rowSelected.NRVINCULOM
    };

    await DocumentosController.changeStatusAssinatura(rowChange);
  }

  private async reprovaAssinatura() {
    const rowChange =   {
      FILE: '',
      ISACEITE: 'N',
      NRINTELETRDIGIT: this.rowSelected.NRINTELETRDIGIT,
      ISACEITEGESTOR: this.rowSelected.ISACEITEGESTOR,
      DSREJEICAO: this.row.DSREJEICAO,
      NRVINCULOM: this.rowSelected.NRVINCULOM
    };

    await DocumentosController.changeStatusAssinatura(rowChange);
  }

  private naoFoiEncontradoPeriodo() {
    const message = 'Não encontrado nenhum período desse relatório!';
    SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);
  }

  private async verificaAssinaturaVinculo(nrvinculom) {
    try {
      await DocumentosController.verificaAssinaturaVinculo(true, nrvinculom);
    } catch (error) {}
  }

  // #endregion
}

export default AprovaReprovaAssinaturaPopup;